import { INavigation } from '@/store/modules/tollDomain/types';

export const initNavigationData: INavigation = {
  start: 0,
  domainsPerPage: 50,
  direction: 'forward',
  isLastDomainPage: false
};

export default initNavigationData;
